import { HttpError } from '@/api/errors'

import type { AuthTokenResponse } from '@/lib/types'

/**
 * POST $origin/auth-token — exchanges the opaque `sessionData` for a
 * short-lived JWT used by every subsequent internal-api call. Bit-exact
 * port of the webpack-era `InternalTokenApiClient.createAuthToken`.
 *
 * Auth: **none** on this endpoint (the only unauthenticated internal-api
 * call). See specs/app/index.md::Internal API contract.
 */
export async function createAuthToken(origin: string, encodedSessionData: string): Promise<AuthTokenResponse> {
  const response = await fetch(`${origin}/auth-token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_data: encodedSessionData }),
  })
  if (!response.ok) {
    throw new HttpError(`HTTP error - status: ${response.status}`, response.status)
  }
  return (await response.json()) as AuthTokenResponse
}
